// extracted by mini-css-extract-plugin
module.exports = {"container":"SideTimePass_container__2Px3R","line":"SideTimePass_line__1XiBe","button":"SideTimePass_button__1Sdk9"};